<template>
  <md-input-item
    v-model.trim="innerValue"
    :type="type"
    :title="title"
    :name="name"
    :placeholder="title"
    :error="error"
    is-title-latent
    class="my-input"
    :readonly="readonly"
    :maxlength="maxlength"
    :disabled="disabled"
    @blur="onBlur"
  >
    <md-icon v-if="showArrow" slot="right" name="arrow-right" />
  </md-input-item>
</template>

<script>
import { InputItem, Icon } from 'mand-mobile'
export default {
  name: 'InputValidate',
  components: {
    [InputItem.name]: InputItem,
    [Icon.name]: Icon
  },
  props: {
    showArrow: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    title: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      innerValue: ''
    }
  },
  watch: {
    value: {
      handler (val) {
        this.innerValue = val
      },
      immediate: true
    },
    innerValue (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    onBlur () {
      this.$emit('blur')
      // 处理ios系统表单页面不滚动
      const u = navigator.userAgent
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isiOS) {
        window.scroll(0, 0)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/* stylelint-disable selector-pseudo-element-no-unknown, no-duplicate-selectors */
.my-input {
  ::v-deep .md-field-item-content {
    min-height: 112px;
    padding-top: 24px;

    .md-field-item-title {
      font-size: 24px;
      color: #b2b2b2;
    }

    .md-input-item-input {
      color: #333;
      -webkit-text-fill-color: #333;
      font-size: 28px;
      font-weight: 400;
      height: 88px;
      line-height: 0.88;
      padding-left: 0;
    }

    &::before {
      border-color: #f1f1f1;
    }

    input::-webkit-input-placeholder {
      font-size: 24px;
      color: #b2b2b2;
      -webkit-text-fill-color: #b2b2b2;
    }
  }
}
/* stylelint-enable */
</style>
